import { useMediaQuery } from '@mui/material'

import {
  ChatAssistant,
  chatStyles
} from '@f-fertighaus/applications/ChatAssistant/ChatAssistant'
import { ClientOnly } from '@f-fertighaus/components/ClientOnly/ClientOnly'

import { useHouseDetail } from '../../utils/context/HouseDetail'

export const ChatAssistantWrapper = () => {
  const { vendor, state } = useHouseDetail()
  const isMobileView = useMediaQuery('(max-width: 900px)')

  return (
    <ClientOnly>
      <ChatAssistant
        vendorNid={vendor.nid}
        vendorName={vendor.display_name}
        vendorSlug={vendor.slug}
        style={{
          ...chatStyles.default,
          chatButtonStyle: {
            ...chatStyles.default.chatButtonStyle,
            ...(isMobileView && {
              bottom: '82px',
              right: '8px',
              padding: '16px 8px',
              height: '48px'
            })
          }
        }}
        wtLabel='chat-icon-house-detail'
        houseNid={state.nid}
      />
    </ClientOnly>
  )
}
